import React, { createContext, useContext, useEffect, useState } from 'react';

import { subscribeTranslations } from './utils/preload';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('locale') || 'en';
  });
  const [translations, setTranslations] = useState(null);

  useEffect(() => {
    const unsubscribe = subscribeTranslations((loadedTranslations) => {
      setTranslations(loadedTranslations);
    });
    return unsubscribe;
  }, []);

  const toggleLocale = () => {
    setLocale((prev) => {
      const next = prev === 'en' ? 'zh' : 'en';
      localStorage.setItem('locale', next);
      return next;
    });
  };

  const t = (key, variables = {}) => {
    if (!translations || !translations[locale]) {
      // Fallback simple translation until loaded
      return key;
    }

    const keys = key.split('.');
    let value = translations[locale];
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) break;
    }

    if (typeof value !== 'string') return key;

    let result = value;
    Object.entries(variables).forEach(([k, v]) => {
      result = result.replace(new RegExp(`{${k}}`, 'g'), String(v));
    });
    return result;
  };

  return (
    <LanguageContext.Provider
      value={{ locale, toggleLocale, t, isLoading: !translations }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}
